import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminChainsawEdit from "@/pages/admin/AdminChainsawEdit";

export const Route = createFileRoute("/admin/chainsaws/$id")({
  component: () => (
    <ProtectedRoute>
      <AdminChainsawEdit />
    </ProtectedRoute>
  ),
});
